import React, { memo } from "react";

const SwitchModeIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path
        d="M6.64309 0.611244C4.5787 1.93753 3.18322 4.27871 3.18322 6.95435C3.18322 9.62998 4.5787 11.9712 6.67769 13.2975C3.13709 13.2975 0.299988 10.4604 0.299988 6.95435C0.299988 5.27205 0.968277 3.65866 2.15784 2.4691C3.3474 1.27953 4.9608 0.611244 6.64309 0.611244ZM19.9867 2.34118L21.6359 3.99039L3.67913 21.9471L2.02993 20.2979L19.9867 2.34118ZM12.8593 5.14368L11.1525 4.07112L9.49172 5.22441L9.97611 3.26382L8.37303 2.04133L10.3913 1.90293L11.0602 0L11.8329 1.87987L13.8281 1.91446L12.2712 3.21768L12.8593 5.14368ZM9.05347 9.30706L7.71565 8.46516L6.42397 9.36473L6.81609 7.84238L5.559 6.88515L7.12747 6.78135L7.64646 5.29361L8.23463 6.75829L9.80311 6.79289L8.59215 7.79625L9.05347 9.30706ZM19.9059 13.8741C19.9059 15.5564 19.2377 17.1698 18.0481 18.3594C16.8585 19.5489 15.2451 20.2172 13.5628 20.2172C12.1558 20.2172 10.8526 19.7559 9.80311 18.9832L18.6719 10.1144C19.4446 11.1639 19.9059 12.4671 19.9059 13.8741ZM14.8315 21.4628L18.0261 20.1365L17.7493 24L14.8315 21.4628ZM19.8252 18.3489L21.1515 15.1543L23.6887 18.0836L19.8252 18.3489ZM21.1515 12.6285L19.8368 9.42239L23.6887 9.69918L21.1515 12.6285ZM9.0996 20.1365L12.2942 21.4628L9.37639 23.9885L9.0996 20.1365Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { SwitchModeIcon };
